import React from "react";

// Screen Reader Only Element
// Used to read out values for for non interactive elements
const SrOnly = ({ label }) => (
    <span role="textbox" aria-label={label} tabIndex={0} className="sr-only" />
);

export default SrOnly;
